<template>
  <div class="calendar">
    <div class="year">{{year}}</div>
    <div class="month">
      <i class="fas fa-caret-left btn" @click="prevMonth"></i>
      <div class="month-label">{{monthLabel}}</div>
      <i class="fas fa-caret-right btn" @click="nextMonth"></i>
    </div>
    <div class="day">SUN</div>
    <div class="day">MON</div>
    <div class="day">TUE</div>
    <div class="day">WED</div>
    <div class="day">THU</div>
    <div class="day">FRI</div>
    <div class="day">SAT</div>
    <div
      class="date"
      v-for="date in displayedDate"
      :class="applyDateStyle(date)"
      @click="pickDate(date)"
    >{{ date.getDate()}}</div>
    <div class="alert" :class="{hide:!showErrMsg}" @click="closeErrMsg">
      <i class="fas fa-exclamation-circle"></i>
      <div>{{ errMsg }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    bookedDates: {
      type: Array,
      required: false,
      default() {
        // [new Date(y,m,d)]
        return [];
      }
    }
  },
  mounted() {
    const d = new Date();
    this.year = d.getFullYear();
    this.month = d.getMonth() + 1;
    this.date = d;
  },
  methods: {
    pickDate(date) {
      this.closeErrMsg();
      // date is today
      if (
        date.getTime() ===
        new Date(
          this.date.getFullYear(),
          this.date.getMonth(),
          this.date.getDate()
        ).getTime()
      ) {
        this.throwErrMsg(
          "Please contact us directly to make reservation of today"
        );
        return;
      }
      // date is in the past
      if (date < this.date) {
        this.throwErrMsg("Date in the past");
        return;
      }
      // date is over 90 days in the future
      if (date - this.date > 86400000 * 90) {
        this.throwErrMsg("Reservation is only available within 90 days");
        return;
      }
      // date is reserved
      for (let i = 0; i < this.bookedDates.length; i++) {
        if (this.bookedDates[i].getTime() === date.getTime()) {
          this.throwErrMsg("This date is reserved");
          return;
        }
      }
      this.closeErrMsg();
      this.pushReservationDate(date);
    },
    pushReservationDate(date) {
      if (!this.reservationStartDate) {
        this.reservationStartDate = date;
      } else if (!this.reservationEndDate) {
        this.reservationEndDate = date;
        if (this.reservationEndDate < this.reservationStartDate) {
          this.reservationEndDate = this.reservationStartDate;
          this.reservationStartDate = date;
        }
      } else {
        this.reservationStartDate = date;
        this.reservationEndDate = undefined;
      }
      this.bookedDates.forEach(d => {
        if (d >= this.reservationStartDate && d <= this.reservationEndDate) {
          this.reservationStartDate = undefined;
          this.reservationEndDate = undefined;
          this.throwErrMsg("Some dates are reserved");
        }
      });
    },
    nextMonth() {
      this.month++;
      if (this.month > 12) {
        this.month = 1;
        this.year++;
      }
    },
    prevMonth() {
      this.month--;
      if (this.month < 1) {
        this.month = 12;
        this.year--;
      }
    },
    nextYear() {
      this.year++;
    },
    prevYear() {
      this.year--;
    },
    applyDateStyle(date) {
      return {
        offMonth: date.getMonth() + 1 != this.month,
        today:
          date.getFullYear() === new Date().getFullYear() &&
          date.getMonth() === new Date().getMonth() &&
          date.getDate() === new Date().getDate(),
        pickedDate:
          date > this.reservationStartDate && date < this.reservationEndDate,
        startDate:
          date >= this.reservationStartDate &&
          date <= this.reservationStartDate,
        endDate:
          date >= this.reservationEndDate && date <= this.reservationEndDate,
        past: date < this.date,
        future: date - this.date > 86400000 * 90,
        booked: this.isBooked(date)
      };
    },
    isBooked(date) {
      let bool = false;
      this.bookedDates.forEach(d => {
        if (d.getTime() === date.getTime()) {
          bool = true;
        }
      });
      return bool;
    },
    throwErrMsg(msg = "err", time = 2000) {
      this.errMsg = msg;
      this.showErrMsg = true;
    },
    closeErrMsg() {
      this.showErrMsg = false;
    }
  },
  data() {
    return {
      year: undefined,
      month: undefined,
      date: undefined,
      showErrMsg: false,
      errMsg: "error"
    };
  },
  computed: {
    reservationStartDate: {
      get() {
        return this.$store.state.reservationStartDate;
      },
      set(val) {
        this.$store.commit("SET_RESERVATION_START_DATE", val);
      }
    },
    reservationEndDate: {
      get() {
        return this.$store.state.reservationEndDate;
      },
      set(val) {
        this.$store.commit("SET_RESERVATION_END_DATE", val);
      }
    },
    monthLabel() {
      switch (this.month) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },
    displayedDate() {
      const ar = [];
      for (let i = -5; i <= 37; i++) {
        ar.push(new Date(this.year, this.month - 1, i));
      }
      // find the first Sunday
      for (let i = 0; i < 7; i++) {
        if (ar[i].getDay() === 0) {
          ar.splice(0, i);
          break;
        }
      }
      // find the last Saturday
      for (let i = ar.length - 1; i > 0; i--) {
        if (ar[i].getDay() === 6) {
          ar.splice(i + 1);
          break;
        }
      }
      return ar;
    }
  }
};
</script>

<style lang="scss" scoped>
.calendar {
  text-align: center;
  display: grid;
  position: relative;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 48px;
  > * {
    padding: var(--g-m) 0;
  }
}
.month,
.year,
.day {
  display: flex;
  justify-content: space-evenly;
  text-transform: uppercase;
  font-weight: bold;
}
.year {
  grid-column-start: 1;
  grid-column-end: 3;
}
.month {
  grid-column-start: 3;
  grid-column-end: 8;
}

.day,
.date {
  text-transform: uppercase;
  font-weight: bold;
  font-size: var(--fs-s);
}
.date {
  transition: background-color 0.3s;
  &:hover {
    cursor: pointer;
    background-color: var(--color-bck);
  }
  &.offMonth {
    color: var(--text-color-lightest);
  }
  &.pickedDate {
    background-color: var(--color-bck);
    color: var(--text-color-lighter);
  }
  &.startDate,
  &.endDate {
    background-color: var(--text-color-lightest);
    color: white;
  }
  &.booked {
    color: var(--color-alert);
    text-decoration: underline;
  }
  &.past {
    text-decoration: line-through;
    background-color: initial;
  }
  &.future {
    background-color: var(--color-warn);
  }
  &.today {
    color: transparent;
    position: relative;
    &::after {
      content: "now";
      color: black;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      text-decoration: underline;
    }
  }
}

.month-label {
  flex-grow: 2;
  flex-basis: 0;
}

.btn {
  cursor: pointer;
  flex-grow: 1;
  flex-basis: 0;
}
.alert {
  font-weight: bold;
  font-size: var(--fs-s);
  i {
    margin-right: 5px;
  }
  color: var(--color-alert);
  text-align: left;
  padding: var(--g-m);
  display: flex;
  flex-flow: row;
  position: absolute;
  top: 100%;
  left: 0;
  opacity: 1;
  transition: opacity 0.5s;
}
.hide {
  opacity: 0;
}
</style>